import { render, staticRenderFns } from "./addBranch.vue?vue&type=template&id=37b52107"
import script from "./addBranch.vue?vue&type=script&lang=js"
export * from "./addBranch.vue?vue&type=script&lang=js"
import style0 from "./addBranch.vue?vue&type=style&index=0&id=37b52107&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports